import { ShortcutBase } from './ShortcutBase';
import { ScenarioStatisticShortcut, IQueryEntityRisksTableOptions } from '../../../models/query/scenarioStatistics';
import { ShortcutType, IQueryShortcutOptions } from '../../../models/query/scenarioStatistics/shortcuts';
import { IScenarioStatisticsResponse, IEntity, TPortfolioEntityGetResponse, IScenarioStatisticsResponsePeriod, IRiskEntity } from '../../../models/portal';
import { FundResult, IPortfolioStatisticsResult } from '../../../models/portal/common/statistics/response/result';
import { ScenarioStatisticQuery } from '../../ScenarioStatisticQuery';
import { deepMergeObjects } from '../../../utils/object';
import { Query } from '../../Query';
import { sortBy } from '../../../utils/collection';
import { IExecutionOptions } from '../../../models/query';

export class EntityRisksTableShortcut extends ShortcutBase {
	constructor(scenarioStatisticQuery: ScenarioStatisticQuery) {
		super(ScenarioStatisticShortcut.entityRisksTable, ShortcutType.directResponse, scenarioStatisticQuery);
	}
	getDirectResponse(shortcutOptions: IQueryShortcutOptions, scenarioStatistics: IScenarioStatisticsResponse) {
		const getTableRow = (options: IQueryEntityRisksTableOptions = {}, entityResult?: FundResult, entity?: IEntity, portfolioEntity?: TPortfolioEntityGetResponse) => {
			const response = {};
			const { fields } = options;
			const workingExecutionOptions = deepMergeObjects(
				this.scenarioStatisticQuery.executionOptions,
				{},
			) as IExecutionOptions;
			if (entity || portfolioEntity) {
				if (!workingExecutionOptions.context) {
					workingExecutionOptions.context = {};
				}
				if (entity && entity.type) {
					if (!workingExecutionOptions.context.entityByType) {
						workingExecutionOptions.context.entityByType = {};
					}
					workingExecutionOptions.context.entityByType[entity.type] = entity as any;
				}
				if (portfolioEntity) {
					workingExecutionOptions.context.portfolioEntity = portfolioEntity;
				}
			}
			fields.forEach((field) => {
				const { key, entityQuery, statisticQuery } = field;
				let value: any = undefined;
				if (entityQuery) {
					const query = new Query(entityQuery);
					value = query.execute(workingExecutionOptions);
				}
				else if (statisticQuery) {
					value = this.scenarioStatisticQuery.getValueForEntity(entityResult, statisticQuery);
				}
				response[key] = value;
			});
			if (!portfolioEntity) {
				response['_isRiskRow'] = true;
			}
			return response;
		};
		const getEntityRiskStatistics = (period: IScenarioStatisticsResponsePeriod, type: 'individual' | 'comparison', entityRiskClientCode?: string, comparisonId?: string, defaultFund?: FundResult) => {
			let response: FundResult | undefined = defaultFund;
			if (entityRiskClientCode) {
				const entityRisk = period.entityRisks.find(entityRisk => entityRisk.clientCode === entityRiskClientCode);
				if (entityRisk) {
					let funds: IPortfolioStatisticsResult['funds'] = [];
					if (type === 'individual') {
						comparisonId = entityRisk.entityId.toString();
						funds = entityRisk.individual.funds;
					}
					if (type === 'comparison') {
						funds = entityRisk.comparison.funds;
					}
					if (funds && comparisonId) {
						response = funds.find(fund => fund.name === comparisonId) || defaultFund;
					}
				}
			}
			return response;
		};
		const tableOptions = shortcutOptions.options && shortcutOptions.options.entityRisksTable && shortcutOptions.options.entityRisksTable;
		let response: any[] = [];
		const periodType = this.scenarioStatisticQuery.getSinglePeriodType(shortcutOptions.periods);
		const portfolioId = this.scenarioStatisticQuery.getSinglePortfolioId(shortcutOptions.portfolios);
		if (periodType && portfolioId) {
			const riskEntities = (this.scenarioStatisticQuery.scenario && this.scenarioStatisticQuery.scenario.riskEntities) || [];
			const riskEntitiesByRelatedPortfolioId: { [key: string]: IRiskEntity } = riskEntities.reduce((acc, riskEntity) => {
				const { relatedPortfolioEntityIds = [] } = riskEntity;
				relatedPortfolioEntityIds.forEach((portfolioEntityId) => {
					acc[portfolioEntityId.toString()] = riskEntity;
				});
				return acc;
			}, {});
			const { periods = [] } = scenarioStatistics;
			const period = periods.find(period => period.periodType === periodType);
			if (period) {
				const { portfolios = [], benchmark } = period;
				const allPortfolios = [...portfolios];
				if (benchmark) {
					allPortfolios.push(benchmark);
				}
				const portfolio = allPortfolios.find(portfolio => portfolio.id === portfolioId);
				if (portfolio) {
					const { funds = [] } = portfolio;
					const orderedFunds = sortBy(funds, (fund) => {
						const entityRisk = riskEntitiesByRelatedPortfolioId[fund.name];
						return (entityRisk && entityRisk.clientCode) || 'ZZZZZZZZZ';
					});
					let entityRisk: IRiskEntity | undefined;
					const scenarioPortfolio = this.scenarioStatisticQuery.scenario &&
						this.scenarioStatisticQuery.scenario.portfolios &&
						this.scenarioStatisticQuery.scenario.portfolios.find(scenarioPortfolio => this.scenarioStatisticQuery.idEquals(scenarioPortfolio.portfolioId, portfolio.id));
					if (scenarioPortfolio) {
						const portfolioEntities = scenarioPortfolio.entities || [];
						response = orderedFunds.reduce((acc, fund) => {
							const portfolioEntity = portfolioEntities.find(portfolioEntity => this.scenarioStatisticQuery.idEquals(portfolioEntity.portfolioEntityId, fund.name));
							if (portfolioEntity && portfolioEntity.entity) {
								const newEntityRisk = riskEntitiesByRelatedPortfolioId[fund.name];
								const fundRiskStatistics = getEntityRiskStatistics(period, 'comparison', newEntityRisk && newEntityRisk.clientCode, portfolioEntity.entityId.toString(), fund);
								const fundTableRow = getTableRow(tableOptions, fundRiskStatistics, portfolioEntity.entity, portfolioEntity);
								acc.push(fundTableRow);
								if ((!newEntityRisk && entityRisk) || (newEntityRisk && !entityRisk) || (newEntityRisk && entityRisk && newEntityRisk.clientCode !== entityRisk.clientCode)) {
									if (entityRisk) {
										const riskEntityTableRow = getTableRow(tableOptions, getEntityRiskStatistics(period, 'individual', entityRisk.clientCode), entityRisk.entity);
										acc.push(riskEntityTableRow);
									}
									entityRisk = newEntityRisk;
								}
							}
							return acc;
						}, []);
						if (entityRisk) {
							const riskEntityTableRow = getTableRow(tableOptions, getEntityRiskStatistics(period, 'individual', entityRisk.clientCode), entityRisk.entity);
							response.push(riskEntityTableRow);
						}

					}
				}
			}
		}
		return response;
	}
}